export class User {
  email: string;
  emailVerified: boolean;
  name: string;
  role: Role;
  teamAuthorization?: TeamAuthorization; // Role#TeamAdminの場合のみ保持する、アクセス可能なteamIdとその権限

  constructor(email: string, emailVerified: boolean, name: string, role: Role, teamAuthorization?: TeamAuthorization) {
    this.email = email;
    this.emailVerified = emailVerified;
    this.name = name;
    this.role = role;
    this.teamAuthorization = teamAuthorization;
  }
}

export interface TeamAuthorization {
  adminTeamIds: number[]; // 管理者権限を持っているteamIds。ambassadorTeamIdsと排他
  ambassadorTeamIds: number[]; // アンバサダー権限を持っているteamIds。adminTeamIdsと排他
}

export const isValidRole = (role: Role): boolean => {
  switch (role) {
    case Role.Developer:
    case Role.Admin:
    case Role.TeamAdmin:
      return true;
    default:
      return false;
  }
}

export enum Role {
  Developer = 'Developer',
  Admin = 'Admin',
  Viewer = 'Viewer',
  Staff = 'Staff',
  TeamAdmin = 'TeamAdmin',
}
